import React from 'react';
import PropTypes from 'prop-types';

import DateRangePicker from '@chronos/components/DateRangePicker';
import Checkbox from '@chronos/components/Checkbox';

import * as S from './styled';

const DashboardFilters = ({ filter, onChangeFilter }) => {
  return (
    <S.DashboardFilters>
      <S.FilterItem>
        <S.SelectSide>
          <DateRangePicker
            ranges={filter.date.ranges}
            onChange={(ranges) => {
              onChangeFilter('date', ranges.selection);
            }}
          />
        </S.SelectSide>
      </S.FilterItem>

      <S.FilterItem>
        <S.SelectSide
          onClick={() => {
            onChangeFilter('showEUVAT', !filter.showEUVAT);
          }}
        >
          <Checkbox
            isChecked={filter.showEUVAT}
            label="€ EU with ％VAT"
            isIndeterminate={false}
          />
        </S.SelectSide>
      </S.FilterItem>

      <S.FilterItem>
        <S.SelectSide
          onClick={() => {
            onChangeFilter('showEUWithoutVAT', !filter.showEUWithoutVAT);
          }}
        >
          <Checkbox
            isChecked={filter.showEUWithoutVAT}
            label="€ EU without VAT 👤"
            isIndeterminate={false}
          />
        </S.SelectSide>
      </S.FilterItem>

      <S.FilterItem>
        <S.SelectSide
          onClick={() => {
            onChangeFilter('showNotEU', !filter.showNotEU);
          }}
        >
          <Checkbox
            isChecked={filter.showNotEU}
            label="🌎 Not EU"
            isIndeterminate={false}
          />
        </S.SelectSide>
      </S.FilterItem>
    </S.DashboardFilters>
  );
};

DashboardFilters.propTypes = {
  filter: PropTypes.shape({
    showEUVAT: PropTypes.bool,
    showEUWithoutVAT: PropTypes.bool,
    showNotEU: PropTypes.bool,

    date: PropTypes.shape({
      minDate: PropTypes.instanceOf(Date),
      maxDate: PropTypes.instanceOf(Date),
      ranges: PropTypes.arrayOf(
        PropTypes.shape({
          startDate: PropTypes.instanceOf(Date),
          endDate: PropTypes.instanceOf(Date),
          key: PropTypes.string,
        })
      ),
    }),
  }),
  onChangeFilter: PropTypes.func,
};

export default DashboardFilters;
